<ol class="breadcrumb m-0">
  <ng-container *ngFor="let item of breadcrumbItems">
    <li class="breadcrumb-item" *ngIf="item.link"><a [routerLink]="item.link">{{ displayLabel(item) }}</a>
    </li>
    <li class="breadcrumb-item active" *ngIf="!item.link">{{ displayLabel(item) }}
    </li>
  </ng-container>
</ol>